"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _asObject = _interopRequireDefault(require("./lib/asObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var XButton = function XButton(_ref) {
  var onRemove = _ref.onRemove,
      option = _ref.option,
      index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "x-button",
    onClick: function onClick(event) {
      event.stopPropagation();
      onRemove((0, _asObject["default"])(option).value, index);
    }
  });
};

var Token = function Token(_ref2) {
  var index = _ref2.index,
      option = _ref2.option,
      name = _ref2.name,
      selected = _ref2.selected,
      currentValue = _ref2.currentValue,
      onSelect = _ref2.onSelect,
      onRemove = _ref2.onRemove;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'token' + (onSelect ? ' selectable' : ''),
    title: option.title,
    disabled: option.disabled,
    onClick: onSelect
  }, name, onRemove ? /*#__PURE__*/_react["default"].createElement(XButton, {
    onRemove: onRemove,
    option: option,
    index: index
  }) : null);
};
/** TokenList */


var _default = function _default(_ref3) {
  var options = _ref3.options,
      value = _ref3.value,
      className = _ref3.className,
      onSelect = _ref3.onSelect,
      onRemove = _ref3.onRemove;
  var isStringArray = options && typeof options[0] === 'string';
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'token-list ' + (className || '')
  }, options && options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(Token, {
      key: index,
      index: index,
      option: option,
      name: isStringArray ? option : option.name,
      currentValue: value,
      selected: (isStringArray ? option : option.value) === value,
      onSelect: onSelect && function (event) {
        return onSelect(isStringArray ? option : option.value, index);
      },
      onRemove: onRemove
    });
  }));
};

exports["default"] = _default;